import { render, staticRenderFns } from "./GeneralDetail.vue?vue&type=template&id=960a31de"
import script from "./GeneralDetail.vue?vue&type=script&lang=js"
export * from "./GeneralDetail.vue?vue&type=script&lang=js"
import style0 from "./GeneralDetail.vue?vue&type=style&index=0&id=960a31de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports